import { API } from '../../../config';
import { errorHandler } from '../auth/errorAction';

export const unmountListCandidateRequest = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_CANDIDATE_REQUEST'})
}

export const unmountDetailCandidateRequest = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DETAIL_CANDIDATE_REQUEST'})
}

export const unmountMasterCandidateRequest = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_MASTER_CANDIDATE_REQUEST'})
}

export const listCandidateRequest = (meta) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_CANDIDATE_REQUEST' })
  return API.GET('/candidate_recommendation/list', meta).then((response) => {
    dispatch({
      type: 'LOAD_DATA_CANDIDATE_REQUEST_SUCCESS', 
      payload: {
        data: response.data,
        pagination: {
          page: response.meta.page,
          total: response.meta.total,
          perpage: response.meta.perpage
        }
    }})
  }).catch((err) => {
    return dispatch(errorHandler(
      err, 
      dispatch({ type: 'LOAD_DATA_CANDIDATE_REQUEST_FAILED' }), 
    ))
  })
}

export const detailCandidateRequest = (id, successCB, failedCB) => async dispatch => {
  await dispatch({ type: 'LOAD_DETAIL_CANDIDATE_REQUEST' })
  const params = {
    'id': id
  }
  API.GET('/candidate_recommendation/getById', params).then((response) => {
    dispatch({ 
      type: 'LOAD_DETAIL_CANDIDATE_REQUEST_SUCCESS', 
      payload : { 
        data: response.data 
      } 
    })
    return successCB && successCB(response)
  }).catch((err) => {
    return (
      failedCB && failedCB(err),
      dispatch(errorHandler(
        err, 
        dispatch({ type: 'LOAD_DETAIL_CANDIDATE_REQUEST_FAILED' }), 
      ))
    )
  })
}

export const masterCandidateRequest = (successCB, failedCB) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_MASTER_CANDIDATE_REQUEST' })
  return API.GET('/employers_type/index').then((response) => {
    dispatch({
      type: 'LOAD_DATA_MASTER_CANDIDATE_REQUEST_SUCCESS', 
      payload: {
        data: response.data,
        pagination: {
          page: null,
          total: null,
          perpage: null
        }
    }})
    return successCB && successCB(response.data)
  }).catch((err) => {
    failedCB && failedCB()
    return dispatch(errorHandler(
      err, 
      dispatch({ type: 'LOAD_DATA_MASTER_CANDIDATE_REQUEST_FAILED' }), 
    ))
  })
}

export const approveCandidateRequest = (value, successCB, failedCB) => () => {
  API.POST_WITH_PARAMS('/candidate_recommendation/approve', value).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const editCandidateRequest = (value, successCB, failedCB) => () => {
  API.POST_WITH_PARAMS('/candidate_recommendation/update', value).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const rejectCandidateRequest = (value, successCB, failedCB) => () => {
  const params = {
    id: value.id,
    rejectReason: value.rejectReason
  }
  API.POST_WITH_PARAMS('/candidate_recommendation/reject', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}